import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

/**
 * 採用ページ 先輩社員インタビュー SP専用オートループスライダー
 * PCは既存の横スクロールのまま、SP(768px以下)のみSwiper化する
 */
const recruitInterviewSlider = () => {
    const el = document.querySelector('.js-recruit-interview_swiper');
    if (!el) return;

    const mq = window.matchMedia('(max-width: 768px)');
    let swiper = null;

    const toggle = (isSp) => {
        if (isSp && !swiper) {
            swiper = new Swiper(el, {
                modules: [Pagination, Autoplay],
                loop: true,
                slidesPerView: 'auto',
                // 間隔はspaceBetweenではなくスライド左右のCSSマージンで付ける
                // (spaceBetweenは右マージンのみになりcenteredSlidesの停止位置がずれるため)
                centeredSlides: true,
                spaceBetween: 0,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.js-recruit-interview_pagination',
                    clickable: true,
                },
            });
        } else if (!isSp && swiper) {
            swiper.destroy(true, true);
            swiper = null;
        }
    };

    mq.addEventListener('change', (e) => toggle(e.matches));
    toggle(mq.matches);
};

export default recruitInterviewSlider;
